import api from "./http";

// Fee Structures
const createFeeStructure = async (feeStructure) => {
  try {
    const response = await api.post("/fees/structure", feeStructure);
    return response.data;
  } catch (error) {
    console.error("Error creating fee structure:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

const updateFeeStructure = async (feeStructureId, payload) => {
  try {
    const response = await api.patch(
      `/fees/structure/${feeStructureId}`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error updating fee structure:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

const getFeeStructures = async (params = {}) => {
  try {
    const response = await api.get("/fees/structures", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching fee structures:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

// Student Fee Management
const assignFeesToStudent = async (assignmentData) => {
  try {
    const response = await api.post("/fees/assign", assignmentData);
    return response.data;
  } catch (error) {
    console.error("Error assigning fees to student:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

const assignExtraFeeToStudent = async (extraFeeData) => {
  try {
    const response = await api.post("/fees/assign-extra", extraFeeData);
    return response.data;
  } catch (error) {
    console.error("Error assigning extra fee to student:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

const autoAssignFees = async (autoAssignData) => {
  try {
    const response = await api.post("/fees/auto-assign", autoAssignData);
    return response.data;
  } catch (error) {
    console.error("Error auto-assigning fees:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

const getStudentFees = async (studentId, academicYear = null) => {
  try {
    const params = academicYear ? { academicYear } : {};
    const response = await api.get(`/fees/student/${studentId}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching student fees:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

// Get students with fee summary
const getStudentsWithFees = async (params = {}) => {
  try {
    // If academicYear is provided, use it as URL parameter
    if (params.academicYear) {
      const response = await api.get(
        `/fees/student/list/${params.academicYear}`,
      );
      return response.data;
    } else {
      // If no academicYear provided, use the route without parameter
      const response = await api.get("/fees/student/list");
      return response.data;
    }
  } catch (error) {
    console.error("Error fetching students with fees:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

// Payments
const recordPayment = async (paymentData) => {
  try {
    const response = await api.post("/fees/payment", paymentData);
    return response.data;
  } catch (error) {
    console.error("Error recording payment:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

const deletePayment = async (paymentId) => {
  try {
    const response = await api.delete(`/fees/payment/${paymentId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting payment:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

// Apply or update discount for a specific assignment
const applyAssignmentDiscount = async (assignmentId, payload) => {
  try {
    const response = await api.patch(
      `/fees/assignments/${assignmentId}/discount`,
      payload,
    );
    return response.data;
  } catch (error) {
    console.error("Error applying discount:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

const getPaymentHistory = async (studentId, params = {}) => {
  try {
    const response = await api.get(`/fees/payments/${studentId}`, { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching payment history:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

const getRecordedPayments = async (filters = "today") => {
  try {
    const isStringInput = typeof filters === "string";
    const timeframe = isStringInput ? filters : filters?.timeframe || "today";
    const params = { timeframe };

    if (!isStringInput && timeframe === "custom") {
      if (filters?.startDate) params.startDate = filters.startDate;
      if (filters?.endDate) params.endDate = filters.endDate;
    }

    const response = await api.get("/fees/payments/recorded", {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching recorded payments:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

// Reports
const getFeesReportByAcademicYear = async (academicYear) => {
  try {
    const response = await api.get(`/fees/report/${academicYear}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching fees report:", error);
    return { error: error.response?.data?.error || error.message };
  }
};

export {
  applyAssignmentDiscount,
  assignExtraFeeToStudent,
  assignFeesToStudent,
  autoAssignFees,
  createFeeStructure,
  deletePayment,
  getFeesReportByAcademicYear,
  getFeeStructures,
  getPaymentHistory,
  getRecordedPayments,
  getStudentFees,
  getStudentsWithFees,
  recordPayment,
  updateFeeStructure,
};
